var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('simple-button',{attrs:{"mapgl":_vm.mapgl,"module":_vm.module,"layer-id":_vm.layerId,"icon":"bus-hollow","title":"Транспорт","add-handler":_vm.addHandler,"remove-handler":_vm.removeHandler,"layers-ids":_vm.layersIds}})],1),_c('mt-popup',{attrs:{"settings":_vm.popupSettings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }